<script setup>
import apiDriveCartesBancaires from "@/services/http/api-drive/client/cartesBancaires";
import { loadPageWithLoader } from "@/utils/webpack-helper";

definePageMeta({
  middleware: ["authenticated", "forbidden-pro"]
});

const app = useNuxtApp();
const { getAxiosErrorFromAsyncData, getErrorStatus, getErrorMessage } =
  useAxiosHelper();

const aliasMaxParMagasin = ref(4);

const component = computed(() => {
  return loadPageWithLoader(() =>
    import("@/components/pages/mon-compte/mes-cartes-bancaires")
  );
});

const {
  data: res,
  error,
  refresh
} = await useAsyncData((app) =>
  app.$apiDrive.use(apiDriveCartesBancaires).aliasPaiement()
);

const responseError = getAxiosErrorFromAsyncData(error);
if (responseError) {
  const errorNuxt = {
    statusCode: getErrorStatus(responseError),
    statusMessage: getErrorMessage(responseError)
  };
  throw showError(errorNuxt);
}

const cartes = computed(() => {
  return res.value ? res.value.data : [];
});

aliasMaxParMagasin.value = res.value.meta.nb_max_par_magasin
  ? res.value.meta.nb_max_par_magasin
  : 4;
</script>

<template>
  <component
    :is="component"
    :cartes-bancaires="cartes"
    :alias-max-par-magasin="aliasMaxParMagasin"
    @refreshCards="refresh()"
  />
</template>
